import React from "react";
import Loading from './Loading';
 import  { useState, useEffect, useRef } from 'react';
 import { DataGrid } from '@mui/x-data-grid';
 import { configData } from "../config";
 import { Link } from '@mui/material';
import { Helmet } from 'react-helmet';
import './classes/MySalesTasks.css';
import SalespersonSidebar from "./SalespersonSidebar";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from "date-fns";
import Autocomplete from '@mui/material/Autocomplete'; 
import TextField from '@mui/material/TextField';
import moment from 'moment-timezone';
moment.tz.setDefault('America/Los_Angeles');

// import { useMockServer } from '@mui/x-data-grid-generator';

 
    const MySalesTasks =() =>{
        const DOMAIN_URL = configData.DOMAIN_URL;
const columns = [
  
  
  { field: 'actions', headerName: 'Actions' ,sortable: false, cellClassName:'action_column',headerClassName:'action_header',renderCell: (params) => (
      <img className="complete_icon" onClick={() => handleTaskComplete(params.row.id,params.row.owner_drupal_uid)} src={DOMAIN_URL+"images/markcomplete.gif"}></img>
    )},
  { field: 'who', headerName: 'Who',sortable: false, cellClassName:'who_column',headerClassName:'who_header' },
  { field: 'owner', headerName: 'Account',sortable: false, cellClassName:'account_column',headerClassName:'account_header', renderCell: (params) => (
    <><img className="add_event_image" onClick={() => handleModalOpen('add_event_log',params.row.owner_drupal_uid)} src={DOMAIN_URL + "images/outboundcall.gif"}></img><Link href={params.row.owner_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2" }}>
          {params.row.owner}
      </Link></>
    )},
  { field: 'title', headerName: 'Subject', cellClassName:'subject_column',headerClassName:'subject_header', renderCell: (params) => (
    <><img  className="view_task_image" onClick={() => handleViewModalOpen('view_task',params.row.id,params.row.owner_drupal_uid)} src="/basic/web/images/viewtaskdetails.gif" alt="View Task Details" border="0" align="top" /><Link  onClick={() => handleViewModalOpen('view_task',params.row.id,params.row.owner_drupal_uid)} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2" }}>
          {params.row.title}
      </Link></>
      )},
  { field: 'field_priority', headerName: 'Priority',cellClassName:'priority_column',headerClassName:'priority_header'  },
  { field: 'field_due_date', headerName: 'Due Date' ,cellClassName:'durdate_column',headerClassName:'duedate_header'  },
 
];
    const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
  /* Pagination, filter config starts here */
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });
    const [selectedValue, setSelectedValue] = useState(null);
    const app_url = configData.APP_URL;
    var currentdate = new Date().toLocaleDateString();
       const currentDatePST = moment().tz('America/Los_Angeles').format('MM-DD-YYYY');
       const currentDateTimePST = moment().tz('America/Los_Angeles').format('MM/DD/YYYY h:mm:ss A');
      const currentDateCustomTimePST = moment().tz('America/Los_Angeles').set({ hour: 1, minute: 0, second: 0 }).format('MM-DD-YYYY hh:mm:ss A');
       var currenttime = new Date().toLocaleTimeString();
       var currentdatetime = currentdate+' '+currenttime;
        var currentstdate = moment().tz('America/Los_Angeles').format('YYYY-MM-DD');
    const getPreviousDate = () => {
       const previousDayPST = moment.tz('America/Los_Angeles').subtract(1, 'day').format('YYYY-MM-DD');
  return previousDayPST;
    };
   const getStartAndCurrentDates = () => {
    const now = new Date();

    const pstNow = new Date(
      now.toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
    );

    const end = new Date(pstNow);
    end.setHours(0, 0, 0, 0);

    const start = new Date(end);
    start.setDate(end.getDate() - 1);

    return { start, end };
  };

    const initialDates = getStartAndCurrentDates();

    const formatISODate = (date) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    };
    const startDateRef = useRef(null);
    const endDateRef = useRef(null);
    
    // const [formData, setformData] = useState({
    //     subject: '',
    //     sortbypriority:'',
    //     salesperson:'ALL',
    //     // startdate: getPreviousDate(),
    //     // enddate: currentstdate
    //     startdate: formatISODate(initialDates.start),
    //     startdate_obj: initialDates.start,
    //     enddate: formatISODate(initialDates.end),
    //     enddate_obj: initialDates.end
    // });
    const getDefaultFormData = () => {
  const params = new URLSearchParams(window.location.search);

  const queryStart = params.get("start_date");
  const queryEnd = params.get("end_date");

  if (queryStart && queryEnd && !isNaN(new Date(queryStart)) &&!isNaN(new Date(queryEnd))) {
    const start = new Date(queryStart);
    const end = new Date(queryEnd);

    return {
      subject: "",
      sortbypriority: "",
      salesperson: "",
      startdate: queryStart,
      startdate_obj: start,
      enddate: queryEnd,
      enddate_obj: end,
    };
  }

  // PST
  const { start, end } = getStartAndCurrentDates();

  return {
    subject: "",
    sortbypriority: "",
    salesperson: "",
    startdate: formatISODate(start),
    startdate_obj: start,
    enddate: formatISODate(end),
    enddate_obj: end,
  };
};

const [formData, setformData] = useState(getDefaultFormData());

const [appliedFormData, setAppliedFormData] = useState(getDefaultFormData());
    // const [appliedFormData, setAppliedFormData] = useState({
    //      subject: '',
    //     sortbypriority:'',
    //     salesperson:'',
    //     startdate: formatISODate(initialDates.start),
    //     startdate_obj: initialDates.start,
    //     enddate: formatISODate(initialDates.end),
    //     enddate_obj: initialDates.end
    //   });
    const [eventformData, setEventFormData] = useState({
            loggedin_uid: localStorage.getItem('drupal_uid'),
            drupal_uid: '',
            subject: 'Out Bound Call',
            details: ''
        });
    const [viewtaskformData, setViewTaskFormData] = useState({
        loggedin_uid: localStorage.getItem('drupal_uid'),
        drupal_uid: '',
        id:'',
        salesperson: '',
        due_date: '',
        priority: 'High',
        repeat: '',
        frequency: '',
        spantype: 'Day',
        subject: '',
        details: '',
        apply_courses: '',
    });
    const [taskformData, setTaskFormData] = useState({
        loggedin_uid: localStorage.getItem('drupal_uid'),
        drupal_uid: selectedValue,
        salesperson: localStorage.getItem('drupal_uid'),
        due_date: currentDateCustomTimePST,
        priority: 'Medium',
        repeat: '',
        frequency: '',
        spantype: 'Day',
        subject: '',
        details: '',
        apply_courses: '',
        });
    const [taskdetailedview, setTaskDetailedView] = useState({});
    const [tasklist, setTaskList] = useState({});
    const[salespersonList, setSalespersonList] = useState({});
    const[showViewTaskModal, setShowViewTaskModal] = useState(false);
    const[showEventModal, setShowEventModal] = useState(false);
    const[showTaskModal, setShowTaskModal] = useState(false);
    const[userDetails,setUserDetails] = useState({});
    const [searchValue, setSearchValue] = useState('');
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    
    const handleChange = (event) => {
    const { name, value } = event.target;
    setformData({ ...formData, [name]: value });
    
    };
const handleEventFormChange = (event) => {
    const { name, value } = event.target;
    setEventFormData({ ...eventformData, [name]: value });
    
    };
     useEffect(() => {
         getuserloggedinroles();
        },[]);
        async function getuserloggedinroles() {
   
         try {
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
               setUserLoggedInRoles(responsedata.data.roles);
               if(responsedata.data.roles.includes(configData.ROLE_ADMINISTRATOR)) {
                setformData((prevFormData) => ({
                ...prevFormData,
                salesperson: "ALL",
              }));
               }
            } 
        } catch (err) {
            
         }
       
  }
    React.useEffect(() => {
       setIsLoading(true);
        gettasklist();
        getsalespersonlist();
        
        const fetchData = async () => {
          try {
      // Simulate API call to your server
      // In a real application, replace this with your actual fetch logic
      const response = await fetch(app_url+'smwwtask/getsalespersonfulltasklist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          uid: localStorage.getItem('drupal_uid'),
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
          formData:appliedFormData
        }),
      });
      const data = await response.json();
     
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
       }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    };

    fetchData();
  }, [paginationModel, sortModel, filterModel,appliedFormData]); // Re-fetch data when these change
    /* Pagination, filter config ends here */
    
     useEffect(() => {
    // Implement debouncing here if needed
    const fetchData = async () => {
      if (searchValue.trim() === '') {
        setOptions([]); // Clear options if search is empty
        return;
      }
      try {
        // Replace with your actual API call
        const response = await fetch(app_url+'user/getaccountlist?query='+searchValue);
        const data = await response.json();
        setOptions(data.data.result); // Assuming data is an array of objects for Autocomplete
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const handler = setTimeout(() => {
      fetchData();
    }, 500); // Debounce for 500ms

    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);
    const handleModalOpen = (modalname,drupal_uid) => {
        if(modalname == 'add_event_log') {
            getuserdetails(drupal_uid);
            console.log(userDetails);
            setShowEventModal(true);
        }
        if(modalname == 'add_task') {
        setShowTaskModal(true);
        }
        
    };
        const handleViewModalOpen = async (modalname,eventid,uid) => {
        
        
        if(modalname == 'view_task') {
        setShowViewTaskModal(true);
        if(uid && !Number.isNaN(uid)) {
        
                try {
                const response =  await fetch(
                app_url+'smwwtask/getusertaskdetailedview?uid='+uid+'&taskid='+eventid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
                )
                const responsedata =  await response.json();
                
                if(responsedata.data.msg == "Success") {
                    
                    setTaskDetailedView(responsedata.data.result);
                    setViewTaskFormData({ 
                      loggedin_uid: localStorage.getItem('drupal_uid'),
                      drupal_uid: uid,
                      id:responsedata.data.result.id,
                      salesperson: responsedata.data.result.field_assignee,
                      due_date: responsedata.data.result.field_due_date,
                      priority: responsedata.data.result.field_priority,
                      repeat: responsedata.data.result.field_repeat,
                      frequency: responsedata.data.result.field_frequency,
                      spantype: responsedata.data.result.field_frequency_type,
                      subject: responsedata.data.result.title,
                      details: responsedata.data.result.body,
                      apply_courses: responsedata.data.result.field_apply_courses,
                    });
                    
                } 
                } catch (err) {
                }
            }
        }
    };
    const handleModalClose = (modalname) => {
        if(modalname == 'add_event_log') {
        setShowEventModal(false);
        }
       
        if(modalname == 'view_task') {
        setShowViewTaskModal(false);
        setTaskDetailedView({});
        setViewTaskFormData({});
        }
        if(modalname == 'add_task') {
        setShowTaskModal(false);
        }
    };
    
    const handleTaskChange = (e) => {
            const { name, value } = e.target;
           
            setTaskFormData({ ...taskformData, [name]: value });
            console.log(taskformData);
        };
        const handleViewTaskChange = (e) => {
            const { name, value } = e.target;
           
            setViewTaskFormData({ ...viewtaskformData, [name]: value });
            console.log(taskformData);
        };
          const handleDateChange = (date, name) => {
        if (date) {
          setformData(prev => ({
            ...prev,
            [`${name}_obj`]: date,  //  for DatePicker
            [name]: formatISODate(date) // string for backend
          }));
        }
      };

        const handleDateTimeChange = (date) => {
       
        if (date) {
          const formattedDate = format(date, "MM-dd-yyyy h:mm:ss aa"); // Example: 2025-06-21 11:03:00
          console.log(formattedDate);
           setTaskFormData({ ...taskformData, ['due_date']: formattedDate });
          
          // You can now use formattedDate for your application logic
        }
      };
      const handleViewTaskDateChange = (date) => {
       
        if (date) {
          const formattedDate = format(date, "yyyy-MM-dd HH:mm:ss"); // Example: 2025-06-21 11:03:00
           setViewTaskFormData({ ...viewtaskformData, ['due_date']: formattedDate });
          
          // You can now use formattedDate for your application logic
        }
      };
async function getsalespersonlist() {
    
         try {
            const response = await fetch(
                app_url+'viewprofile/getsalespersonlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
        
  }
  
     async function gettasklist(uid) {
            if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'smwwtask/getusertasklist?uid='+uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
                setTaskList(responsedata.data.result);
            } 
        } catch (err) {
            
         }
        }
  }
  async function getuserdetails(uid) {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'smwweventlog/getuserdetails?uid='+uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
                setUserDetails(responsedata.data.result);
                setEventFormData({ ...eventformData, drupal_uid: uid });
            } 
        } catch (err) {
            
         }
        }
  }
  const handleTaskComplete = async (value,uid) => {
        const postData = { 
            uid:uid,
            id:value
        };
        try {
            const response = await fetch(app_url + 'smwwtask/completetask', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
               
               const response = await fetch(app_url+'smwwtask/getsalespersonfulltasklist', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                uid: localStorage.getItem('drupal_uid'),
                page: paginationModel.page,
                pageSize: paginationModel.pageSize,
                sortModel,
                filterModel,
                formData
              }),
          });
            const data = await response.json();
     
            setRows(data.data.rows);
            }
        } catch (err) {
            
        }
    };
   const handleViewTaskSubmit = async (value) => {
       
        const postData = {
          formData: viewtaskformData,
          id: value
          };
        const response = await fetch(app_url + 'smwwtask/updatetask', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
        const data = await response.json();
        if(data.data.msg == "Success") {
             
               const response = await fetch(app_url+'smwwtask/getsalespersonfulltasklist', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                uid: localStorage.getItem('drupal_uid'),
                page: paginationModel.page,
                pageSize: paginationModel.pageSize,
                sortModel,
                filterModel,
                formData
              }),
          });
            const data = await response.json();
      setShowViewTaskModal(false);
            setRows(data.data.rows);
        }
    };
    const handleEventFormSubmit = async event => {
        event.preventDefault();
        const postData = eventformData;
        const response = await fetch(app_url + 'smwweventlog/addevent', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
        const data = await response.json();
        if(data.data.msg == "Success") {
            setShowEventModal(false);
            
        }
    };
    const addtaskvalidate = (data) => {
  const newErrors = {};

  if(!data.subject.trim()) { 
    alert('Event Title is required');
    
    newErrors.subject = 'Event Title is required';
   
  }
  else if(!data.due_date.trim()) { 
    alert('Due Date is required');
    
    newErrors.due_date = 'Due Date is required';
   
  }
   else if(!data.drupal_uid) { 
    alert('Please select the Account');
    
    newErrors.due_date = 'Please select the Account';
   
  }
  
  return newErrors;
  };
     const handleTaskSubmit = async event => {
        event.preventDefault();
         const formErrors = addtaskvalidate(taskformData);

      if (Object.keys(formErrors).length == 0) {
        const postData = taskformData;
        const response = await fetch(app_url + 'smwwtask/addtask', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
        const data = await response.json();
        if(data.data.msg == "Success") {
            setShowTaskModal(false);
            setSearchValue('');
            const response = await fetch(app_url+'smwwtask/getsalespersonfulltasklist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          uid: localStorage.getItem('drupal_uid'),
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
          formData
        }),
      });
      const data = await response.json();
     
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
        }
      }
    };
const handleSubmit = async (e) => {
  e.preventDefault();
  
  // setAppliedFormData({ ...formData });
  setPaginationModel({
    page: 0,
    pageSize: 50,
  });
  let updatedFormData = { ...formData };

  if ((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) && (formData.salesperson === "")) {
    updatedFormData.salesperson = "ALL";
  }
  setAppliedFormData(updatedFormData);
  try {
    setIsLoading(true);
const response = await fetch(app_url+'smwwtask/getsalespersonfulltasklist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          uid: localStorage.getItem('drupal_uid'),
          page: 0,
          pageSize: 50,
          sortModel,
          filterModel,
          formData:updatedFormData
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
  } catch (error) {
    console.error('Error fetching data:', error);
  } finally {
    setIsLoading(false); // Set loading to false after fetch completes (success or error)
  }   
  
}; 
const handleClear = async (e) => {
  e.preventDefault();
    setformData(getDefaultFormData());
    setAppliedFormData(getDefaultFormData());
  try {
    setIsLoading(true);
const response = await fetch(app_url+'smwwtask/getsalespersonfulltasklist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          uid: localStorage.getItem('drupal_uid'),
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
          formData:getDefaultFormData(),
          type:'clear'
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
  } catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
  
}; 

const rowHeight = 32;
const pageSize = paginationModel.pageSize;
const gridHeaderHeight = 56;
const paginationHeight = 56;
const totalHeight = (rowHeight * pageSize) + gridHeaderHeight + paginationHeight;
 
    return(
      <>
               {isLoading ? (
                    <Loading />
                  ) : (
        <div id="main" className="my-sales-tasks-main">
          <Helmet><title>My Tasks</title></Helmet>
             <div class="left"></div>
                <div class="center left-center"> 
                    <div className="my-sales-tasks-container">
                        <div className="my-sales-tasks-view-header">
                          <h1>My Tasks</h1>
                             <div className="header-actions">
                                <input type="button" value="Add Task" id="add-task-btn" onClick={() => handleModalOpen('add_task')} />
                            </div>  <br/>                       
                         </div>
                           <div className="my-sales-tasks-view-filters">
                                <form id="my-tasks-search">
                                    <div className="my-sales-tasks">
                                      <div className="my-sales-tasks-widgets">

                                        {/* Subject */}
                                        <div className="subject_wrapper my-tasks-filter">
                                        <label htmlFor="subject">Subject Contains</label>
                                        <div className="my-sales-tasks-views-widget">
                                            <div className="my-sales-tasks-form-item">
                                            <input
                                                type="text"
                                                id="subject"
                                                name="subject"
                                                size="30"
                                                maxLength="128"
                                                className="my-sales-tasks-form-text" onChange={handleChange} 
                                                value={formData.subject}
                                            />
                                            </div>
                                        </div>
                                        </div>

                                        {/* Priority */}
                                       <div className="priority_wrapper my-tasks-filter">
                                        <label htmlFor="priority">Sort by Priority</label>
                                        <div className="my-sales-tasks-views-widget">
                                            <div className="my-sales-tasks-form-item">
                                           <select name="sortbypriority" id="sortbypriority" value={formData.sortbypriority} onChange={handleChange}>
		                                        <option value="">None</option>
                                            <option value="HML">High,Medium,Low</option>
                                            <option value="LMH">Low,Medium,High</option>
                                            <option value="HLM">High,Low,Medium</option>
                                              </select>
                                            </div>
                                        </div>
                                        </div>
                                        {(                                         
                                          userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) 
                                        ) && (
                                        <div className="salesperson-dropdown my-tasks-filter">
                                      <label>Salesperson:</label>
                                      <div className="my-sales-tasks-views-widget">
                                            <div className="my-sales-tasks-form-item">
                                      <select 
                                      name="salesperson"
                                      value={formData.salesperson}
                                      onChange={handleChange}
                                      >
                                          <option value="ALL">ALL</option>
                                          {salespersonList.length > 0 && (
                                          <>
                                            {salespersonList.map((item, index) => {
                                              return <>
                                                {item['uid'] != null && (
                                                  <><option value={item['uid']}>{item['name']}</option></>
                                                )}
                                              </>
                                              
                                            })}  
                                    
                                          </>
                                          )}
                                        </select>
                                        </div>
                                        </div>
                                        </div>
                                      )}                                       
                                        <div className="clear"></div>
                                        {/* Start Date */}
                                       <div className="start_date_wrapper my-tasks-filter">
                                        <label>Start Date</label>
                                          <div className="my-sales-tasks-views-widget">
                                            <div className="my-sales-tasks-form-item">
                                           <DatePicker
                                            ref={startDateRef}
                                            id="startdate"
                                            name="startdate"
                                            selected={formData.startdate_obj}
                                            onChange={(date) => { handleDateChange(date, 'startdate');
                                               setTimeout(() => {
                                                const input = startDateRef.current?.input;
                                                if (input) {
                                                  const len = input.value.length;
                                                  input.setSelectionRange(len, len);
                                                }
                                              }, 0);
                                            }}                          
                                            placeholderText=""
                                            dateFormat="yyyy-MM-dd"                                            
                                            className="form-input"
                                          />
                                            </div>
                                        </div>
                                        </div>

                                        {/* End Date */}
                                        <div className="end_date_wrapper my-tasks-filter">
                                        <label>End date</label>
                                        <div className="my-sales-tasks-views-widget">
                                            <div className="my-sales-tasks-form-item">
                                           <DatePicker
                                            ref={endDateRef}
                                            id="enddate"
                                            name="enddate"
                                            selected={formData.enddate_obj}
                                            onChange={(date) => {handleDateChange(date, 'enddate');
                                              setTimeout(() => {
                                                const input = endDateRef.current?.input;
                                                if (input) {
                                                  const len = input.value.length;
                                                  input.setSelectionRange(len, len);
                                                }
                                              }, 0);
                                            }}
                                            placeholderText=""
                                            dateFormat="yyyy-MM-dd"
                                            
                                            className="form-input"
                                          />
                                            </div>
                                        </div>
                                        </div>

                                        

                                        {/* Submit Button */}
                                        <div className="my-sales-tasks-views-exposed-widget my-sales-tasks-views-submit-button">
                                        
                                        <button className='form-submit my-sales-tasks-formsubmit' type="submit" onClick={handleSubmit}>Apply</button>
                                        <button className='form-submit my-sales-tasks-formsubmit' type="submit" style={{marginLeft:10}} onClick={handleClear}>Clear</button>
                                        </div>

                                    </div>
                                    </div>
                                </form>
                              </div>
                      
                        <div className="my-sales-tasks-view-content">
                            <table className="my-sales-tasks-views-table">
                                   <div style={{ width: '100%' , 
                                //    height: `${totalHeight}px`,      
                              overflowX: 'clip', }}>
                                    <DataGrid
                                    
                                    rows={rows}
                                    columns={columns}
                                    rowCount={rowCount}
                                   
                                    paginationMode="server"
                                    sortingMode="server"
                                    filterMode="server"
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={setPaginationModel}
                                    sortModel={sortModel}
                                    onSortModelChange={setSortModel}
                                     filterModel={filterModel}
                                    onFilterModelChange={setFilterModel}
                                    // pageSizeOptions={[100, 150, 200]} 
                                        pageSizeOptions={[5, 10, 25,50]}
                                         pageSize={50}
                                     getRowHeight={() => 'auto'}
                                    disableColumnFilter 
                                    disableColumnResize={true}
                                    
                                    
                                />
    </div>
                            </table>
                        </div>

                    </div>
                    {showEventModal && (           
<div id="myModal" class="modal add-event-modal">

 
  <div class="modal-content">
    <div class="modal-header">
      
      <h2>Add Event Log</h2>
      <span class="close"  style={{'cursor':'pointer'}} onClick={() => handleModalClose('add_event_log')}>&times;</span>
    </div>
    <div class="modal-body">
      <form id="athlete_eventlog" method="post">
       
        <p>
  Entering event for: <strong>{userDetails.user_name}</strong><br />
	By User: <strong>{userDetails.loggedin_user_name}</strong><br />
	Start Time:{currentDateTimePST}</p>
<p>
	<strong>Subject:</strong>
	<input type="text" name="subject" defaultValue="Out Bound Call" onChange={handleEventFormChange} />
</p>
<p>
	<strong>Details:</strong>
	<textarea name="details" cols="40" rows="7" onChange={handleEventFormChange} ></textarea>
</p>
<p>
	
	<input type="button" id="btn" name="btn" value="Save" onClick={handleEventFormSubmit}/>
</p>
</form>
    </div>
    <div class="modal-footer">
     
    </div>
  </div>

</div>
  )}
  {showTaskModal && (           
    <div id="myModal" className="modal addtask">
      <div className="modal-content">
        <div class="modal-header">
         
          <h2>Add Task</h2>
           <span class="close"  onClick={() => handleModalClose('add_task')}>&times;</span>
        </div>
        <div class="modal-body">
          <form id="task-add" method="post">
            <table id="add-task-table">
              <tbody>
                <tr><td>Account:</td><td> 
       <div>
      
      <Autocomplete
        id="user_search"
        freeSolo
        options={options}
        onChange={(event, newValue) => setTaskFormData({ ...taskformData, ['drupal_uid']: newValue.id })}
        renderInput={(params) => <TextField {...params}  onChange={(event) => setSearchValue(event.target.value)}/>}
      />
     <span className="help_note">This is a autocomplete field, you can fill in user first name or last name to search.</span>
    </div></td></tr>
                <tr><td>Sales Person:</td>
                <td>
                <select id="salesperson" value={taskformData.salesperson} name="salesperson" onChange={handleTaskChange}>
                  <option value="0"></option>
                  {salespersonList.length > 0 && (
                  <>
                    {salespersonList.map((item, index) => {
                      return <>
                        {item['uid'] != null && (
                          <><option value={item['uid']}>{item['name']}</option></>
                        )}
                      </>
                      
                    })}  
             
                  </>
                  )}
                </select>
                </td>
              </tr>
            <tr>
              <td><strong>Due Date:</strong></td>
              <td>
                <DatePicker
                      id="datetime"
                      selected={taskformData.due_date ? new Date(taskformData.due_date) : null}
                      onChange={handleDateTimeChange}
                      placeholderText=""
                      dateFormat="MM-dd-yyyy h:mm aa"
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={1}
                      className="form-input"
                    />
                </td>
            </tr>
            <tr>
              <td><strong>Priority:</strong></td>
              <td><select name="priority" value={taskformData.priority} onChange={handleTaskChange}>
                  <option value="High">High</option>
                  <option value="Medium" selected="">Medium</option>
                  <option value="Low">Low</option>
              </select></td>
            </tr>
            {/*
            <tr>
              <td><strong>Recurrence:</strong></td>
              <td><input type="checkbox" name="repeat" id="repeat" value="1" onChange={handleTaskChange}/>
              <label for="repeat" >Repeat</label>
              <input type="text" name="frequency" defaultValue="1" size="3" maxlength="1" onChange={handleTaskChange}/>
              times per
              <select name="spantype" onChange={handleTaskChange}>
                  <option value="Day">Day</option>
                  <option value="Week">Week</option>
                  <option value="Month">Month</option>
                  <option value="Year">Year</option>
              </select>
              </td>
            </tr>
            */}
            <tr>
              <td><strong>Event Title:</strong></td>
              <td><input type="text" name="subject" id="subject" onChange={handleTaskChange}/></td>
            </tr>
            <tr>
              <td ><strong>Details:</strong></td>
              <td><textarea name="details" cols="40" rows="7" onChange={handleTaskChange}></textarea></td>
            </tr>
            <tr>
              <td>Course/Conference:</td>
              <td><textarea name="apply_courses" cols="40" rows="3" onChange={handleTaskChange}></textarea></td>
            </tr>
            <tr>
              <td> </td><td>
                <input type="button" id="btn" name="btn" value="Save" onClick={handleTaskSubmit}/>
              </td>
            </tr>
          </tbody>
          </table>
          </form>
      </div>
      <div class="modal-footer">
       
      </div>
    </div>
  
  </div>
    )}
  
{showViewTaskModal && (           
  <div id="myModal" className="modal viewtask">
    <div class="modal-content">
      <div class="modal-header">
        
        <h2>Edit Task</h2>
        <span class="close"  onClick={() => handleModalClose('view_task')}>&times;</span>
      </div>
      <div class="modal-body">
        <form id="task-add" method="post">
          <table id="add-task-table">
            <tbody>
              <tr><td>Scheduled task bound to:</td><td>{taskdetailedview.field_owner_ac_target_id}</td></tr>
              <tr><td>Created:</td><td>{taskdetailedview.created_at}</td></tr>
              <tr><td>By User:</td><td>{taskdetailedview.uid}</td></tr>
              <tr><td>Sales Person:</td>
              <td>
              <select id="salesperson" name="salesperson" onChange={handleViewTaskChange} value={viewtaskformData.salesperson}>
                <option value="0"></option>
                {salespersonList.length > 0 && (
                <>
                  {salespersonList.map((item, index) => {
                    return <>
                      {item['uid'] != null && (
                        <><option value={item['uid']}>{item['name']}</option></>
                      )}
                    </>
                    
                  })}  
           
                </>
                )}
              </select>
              </td>
            </tr>
          <tr>
            <td><strong>Due Date:</strong></td>
              <td>
              <DatePicker
                    id="datetime"
                    selected={viewtaskformData.due_date ? new Date(viewtaskformData.due_date) : null}
                    onChange={handleViewTaskDateChange}
                    placeholderText=""
                    dateFormat="MM-dd-yyyy h:mm aa"
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={1}
                    className="form-input"
                    defaultValue={viewtaskformData.field_due_date}
                  />
              </td>
          </tr>
          <tr>
              <td><strong>Priority:</strong></td>
              <td><select name="priority" value={viewtaskformData.priority} onChange={handleViewTaskChange} >
                  <option value="High">High</option>
                  <option value="Medium" selected="">Medium</option>
                  <option value="Low">Low</option>
              </select></td>
          </tr>
          {/*
          <tr>
              <td><strong>Recurrence:</strong></td>
              <td><input type="checkbox" name="repeat" id="repeat"  onChange={handleViewTaskChange} defaultValue={taskdetailedview.field_repeat}/>
              <label for="repeat" >Repeat</label>
              <input type="text" name="frequency" defaultValue="1" size="3" maxlength="1" onChange={handleViewTaskChange}/>
              times per
              <select name="spantype" defaultValue={taskdetailedview.field_frequency_type} onChange={handleViewTaskChange}>
                  <option value="Day">Day</option>
                  <option value="Week">Week</option>
                  <option value="Month">Month</option>
                  <option value="Year">Year</option>
              </select>
            </td>
          </tr>
          */}
          <tr>
              <td><strong>Event Title:</strong></td>
              <td><input type="text" name="subject" defaultValue={viewtaskformData.subject} id="subject" onChange={handleViewTaskChange}/></td>
          </tr>
          <tr>
              <td ><strong>Details:</strong></td>
              <td><textarea name="details" cols="40" rows="7" defaultValue={viewtaskformData.details} onChange={handleViewTaskChange}></textarea></td>
          </tr>
          <tr>
            <td>Course/Conference:</td>
            <td><textarea name="apply_courses" cols="40" rows="3" defaultValue={viewtaskformData.apply_courses} onChange={handleViewTaskChange}></textarea></td>
          </tr>
          <tr>
            <td> </td><td>
              <input type="button" id="btn" name="btn" value="Save" onClick={()=>handleViewTaskSubmit(taskdetailedview.id)}/>
            </td>
          </tr>
        </tbody>
        </table>
        </form>
    </div>
    <div class="modal-footer">
     
    </div>
  </div>

</div>
  )}
                </div>
       
       <div class="right">
            <SalespersonSidebar/>
        </div>
        </div>
       )}
    </> 
    );
};

export default MySalesTasks;